// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import { fetchBoards } from '../../element/board/boardService';

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchBoards: (boardIds) =>
        dispatch(
            fetchBoards({
                boardIds,
                loadAncestors: true,
            }),
        ),
});

/**
 * This component handles the fetching of breadcrumb elements if they are not already fetched.
 */
export default (DecoratedComponent) => {
    @connect(null, mapDispatchToProps)
    class WorkspaceCurrentBoardFetchDecorator extends React.Component {
        componentWillReceiveProps(nextProps) {
            const { breadcrumbObj, dispatchFetchBoards } = nextProps;
            if (!breadcrumbObj || breadcrumbObj.complete || !breadcrumbObj.missingElementIds) return;

            dispatchFetchBoards(breadcrumbObj.missingElementIds);
        }

        render() {
            const { dispatchFetchBoards, ...rest } = this.props; // eslint-disable-line no-unused-vars
            return <DecoratedComponent {...rest} />;
        }
    }

    WorkspaceCurrentBoardFetchDecorator.propTypes = {
        breadcrumbObj: PropTypes.object,
        dispatchFetchBoards: PropTypes.func,
    };

    return WorkspaceCurrentBoardFetchDecorator;
};
